module.exports = __webpack_public_path__ + "img/rw.60123c46.svg";